import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'

import { routes } from './routes'
import { scrollToElement, getScrollParent } from '@/helpers/scrollToElement'

Vue.use(VueHead, {
	separator: '|',
	complement: 'Мониторинг рыб и других водных животных',
})
Vue.use(VueRouter)

// Прокрутка к якорю; если блок ещё не отрисован — пробуем ещё несколько раз (~3 сек)
function scrollToHash(hash, attempt = 0) {
	const element = document.getElementById(hash.replace(/#/, ''))
	if (element) {
		scrollToElement(element)
		keepAnchorInPlace(element)
	} else if (attempt < 20) {
		setTimeout(() => scrollToHash(hash, attempt + 1), 150)
	}
}

// Пока главная догружается (данные с API, картинки), страница ещё короткая и прокрутка
// упирается в её конец, не доезжая до якоря. Поэтому ~4 сек следим за высотой страницы
// и докручиваем к якорю; прекращаем, как только пользователь прокрутил сам.
function keepAnchorInPlace(element) {
	const container = getScrollParent(element)
	const startedAt = Date.now()
	let lastHeight = container.scrollHeight
	let userScrolled = false
	const onUserScroll = () => {
		userScrolled = true
	}
	const events = ['wheel', 'touchstart', 'keydown']
	events.forEach((name) => window.addEventListener(name, onUserScroll, { passive: true }))

	const timer = setInterval(() => {
		if (userScrolled || Date.now() - startedAt > 4000) {
			clearInterval(timer)
			events.forEach((name) => window.removeEventListener(name, onUserScroll))
			return
		}
		if (container.scrollHeight !== lastHeight) {
			lastHeight = container.scrollHeight
			scrollToElement(element)
		}
	}, 200)
}

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to) {
		if (to.hash) {
			setTimeout(() => scrollToHash(to.hash), 500)
			// При первом заходе картинки и шрифты догружаются позже и сдвигают блоки вниз —
			// после полной загрузки страницы докручиваем ещё раз
			if (document.readyState !== 'complete') {
				window.addEventListener('load', () => scrollToHash(to.hash), { once: true })
			}
			return { selector: to.hash, behavior: 'smooth' }
		} else {
			return { y: 0, behavior: 'smooth' }
		}
	},
})

export default router
